import React, { useEffect, useRef } from "react";
import logo from "./assets/logofinal-flat.png";
import "./HomeV2.css";
import "./FeaturePages.css";
import { PublicFooter, PublicHeaderNav } from "./PublicSiteChrome";

const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.akremanaya.weavevomobile&hl=fr";

export const EXPLORE_LINKS = [
  ["Booking", "/use-cases/booking"],
  ["Hotel", "/use-cases/hotel"],
  ["Real Estate", "/use-cases/real-estate"],
  ["Museum", "/use-cases/museum"],
  ["Live Events", "/use-cases/live-events"],
  ["Sport", "/use-cases/sport"],
  ["Media", "/use-cases/media"],
  ["AI Proposal", "/use-cases/ai-proposal"],
  ["Geolocalisation", "/use-cases/geolocalisation"],
  ["Map", "/use-cases/map"],
  ["Wizard", "/use-cases/wizard"],
];

export function FeatureVideo({ src, poster, className = "" }) {
  const videoRef = useRef(null);

  const playWithSound = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = false;
    const promise = video.play();
    if (promise?.catch) promise.catch(() => {});
  };

  const keepPlayingMuted = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    const promise = video.play();
    if (promise?.catch) promise.catch(() => {});
  };

  return (
    <div className={`fp-videoCard ${className}`} onMouseEnter={playWithSound} onMouseLeave={keepPlayingMuted}>
      <video ref={videoRef} controls autoPlay muted loop playsInline preload="auto" poster={poster}>
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export function FeaturePageShell({
  pageTitle,
  currentPath,
  eyebrow,
  heroTitle,
  heroText,
  heroImage,
  heroAlt,
  heroVisual,
  heroClassName = "",
  finalEyebrow,
  finalTitle,
  finalText,
  children,
}) {
  useEffect(() => {
    document.title = `${pageTitle} | Weavevo`;
    window.scrollTo(0, 0);
  }, [pageTitle]);

  return (
    <div className={`fp-page ${heroClassName}`}>
      <header className="hv2-nav hv2-navPersistent fp-header" aria-label="Weavevo navigation">
        <a className="hv2-brand" href="/" aria-label="Weavevo home">
          <img src={logo} alt="Weavevo" />
          <span>weavevo</span>
        </a>
        <PublicHeaderNav loginHref="/homeV2#product" />
      </header>

      <main>
        <section className="fp-hero">
          {heroImage ? <img className="fp-heroImage" src={heroImage} alt={heroAlt || `${pageTitle} concept`} /> : null}
          <div className="fp-heroScrim" />
          <div className={`fp-heroInner ${heroVisual ? "has-visual" : ""}`}>
            <div className="fp-heroCopy">
              <span className="fp-eyebrow">{eyebrow}</span>
              <h1>{heroTitle}</h1>
              <p>{heroText}</p>
            </div>
            {heroVisual ? <div className="fp-heroVisual">{heroVisual}</div> : null}
          </div>
        </section>

        {children}

        <section className="fp-finalCta">
          <span className="fp-sectionEyebrow">{finalEyebrow}</span>
          <h2>{finalTitle}</h2>
          <p>{finalText}</p>
          <div className="fp-storeActions" aria-label="Download Weavevo">
            <a className="fp-storeButton fp-storeButtonPrimary" href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer">
              <i className="bi bi-google-play" aria-hidden="true" />
              <span>Play Store</span>
            </a>
            <button className="fp-storeButton fp-storeButtonSecondary" type="button" disabled>
              <i className="bi bi-apple" aria-hidden="true" />
              <span>App Store</span>
            </button>
          </div>
        </section>
      </main>

      <PublicFooter className="fp-footer" currentPath={currentPath} />
    </div>
  );
}
